export default __webpack_public_path__ + "static/register-ba63fcd7c8d3216bb10a9ed38d5ee6e0.svg";